export default __webpack_public_path__ + "static/demolition-house-2776beb6204a3b123f53d73c44290cdc.png";